// extracted by mini-css-extract-plugin
export default {"newsDiv":"LatestNews_newsDiv__BtWsY","newsHeading":"LatestNews_newsHeading__cZJSQ"};